// extracted by mini-css-extract-plugin
export default {"studio-actions":"studioActions_studio-actions__YPKzH"};